import type { TimeLeft } from 'shared/models/timer'

export function getTimeDifference(expiredDate: string): TimeLeft {
  const now = new Date()
  const target = new Date(expiredDate)
  const total = Math.max(target.getTime() - now.getTime(), 0)

  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)

  return {
    total,
    hours: formatTimeToValue(hours),
    minutes: formatTimeToValue(minutes),
    seconds: formatTimeToValue(seconds),
  }
}

export const formatTimeToValue = (value?: number): string => {
  if (!value) return '00'

  return String(value).padStart(2, '0')
}
